import React from "react";

const Pagination = ({
  pagination,
  loading,
  currentCount,
  onPageChange,
  onLimitChange, // Thêm prop này
}) => {
  return (
    <div className="px-6 py-4 border-t border-slate-200 bg-slate-50 flex items-center justify-between flex-wrap gap-4">
      {/* Cụm thông tin và chọn Limit */}
      <div className="flex items-center gap-4 text-sm text-slate-500">
        <p>Đang hiển thị {currentCount} kết quả</p>
        
        <div className="flex items-center gap-2 border-l border-slate-300 pl-4">
          <label htmlFor="limit-select" className="font-medium">
            Số dòng / trang:
          </label>
          <select
            id="limit-select"
            value={pagination.limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            disabled={loading}
            className="border border-slate-300 rounded px-2 py-1 bg-white text-slate-700 outline-none focus:border-indigo-500 disabled:opacity-50"
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>

      {/* Cụm nút chuyển trang */}
      <div className="flex gap-2">
        <button
          disabled={pagination.offset === 0 || loading}
          onClick={() => onPageChange("prev")}
          className="px-3 py-1.5 border border-slate-300 rounded-lg text-sm font-medium text-slate-600 bg-white hover:bg-slate-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Trước
        </button>
        <button
          disabled={currentCount < pagination.limit || loading}
          onClick={() => onPageChange("next")}
          className="px-3 py-1.5 border border-slate-300 rounded-lg text-sm font-medium text-slate-600 bg-white hover:bg-slate-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Sau
        </button>
      </div>
    </div>
  );
};

export default Pagination;